var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInspection04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_22170",
    "data-name": "\\uADF8\\uB8F9 22170",
    transform: "translate(8821 -5419)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1580",
    "data-name": "\\uD0C0\\uC6D0 1580",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(-8821 5419)",
    fill: "#003671"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10371",
    "data-name": "\\uD328\\uC2A4 10371",
    d: "M3.843,5.092A4.706,4.706,0,0,1,2.362,5.3,4.237,4.237,0,0,1-.613,4.223,4.872,4.872,0,0,1-2.038.424,4.829,4.829,0,0,1-.575-3.394,4.316,4.316,0,0,1,2.393-4.45a4.257,4.257,0,0,1,3,1.119A4.681,4.681,0,0,1,6.792.286a6.128,6.128,0,0,1-.3,2.062,3.436,3.436,0,0,1-.719,1.319l1.062.994L5.83,5.711,4.717,4.661A4.636,4.636,0,0,1,3.843,5.092ZM3.43,3.43,2.5,2.542l.994-1.037.931.887A4.351,4.351,0,0,0,4.73,1.6,4.531,4.531,0,0,0,4.867.424a3.934,3.934,0,0,0-.634-2.4A2.171,2.171,0,0,0,2.38-2.819a2.26,2.26,0,0,0-1.825.812A3.71,3.71,0,0,0-.125.424,3.361,3.361,0,0,0,.849,3.136a2.272,2.272,0,0,0,1.512.531A2.475,2.475,0,0,0,3,3.586,3.173,3.173,0,0,0,3.43,3.43Z",
    transform: "translate(-8813.4 5428.37)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspection04);
export default __webpack_public_path__ + "static/media/inspection_04.f36747cf48b2329517fe9ce7e034dfdb.svg";
export { ForwardRef as ReactComponent };